import React, { } from 'react';
import JJ_From, { FormItemData } from "../../components/JJ_From";
import api, { GetAreaRes, GetAreaListParameters, GetFoodCardRecordListRes, GetFoodCardRecordParameters, GetFoodCardRecordListParameters, GetKioskVendingRes, GetKioskVendingListParameters } from '../../api';
import { connect, ConnectedProps } from 'react-redux';
import { Select, Tag, DatePicker, Space } from 'antd';
import moment from 'moment';


interface PageState {
  kioskVendings: GetKioskVendingRes[]
}


interface Props {
  onFinish?(values: GetFoodCardRecordListRes): void
}



interface Page {
  /**
   * 保存数据
   */
  _onFinish(values: any): void

  /**
   * 获取数据
   */
  _onLoadData(): Promise<{}>

  id?: string

}


type PageProps = Props & PropsFromRedux

type PropsFromRedux = ConnectedProps<typeof connector>


interface RootState {

}

const mapState = (state: RootState) => ({

})

const mapDispatch = {

}

const connector = connect(
  mapState,
  mapDispatch
)


class FoodCardRecordEditAndAdd extends React.Component<PageProps, PageState> implements Page {

  constructor (props: Readonly<PageProps>) {
    super(props);

    this.state = {
      kioskVendings: []

    }

  }
  componentDidMount() {
  }

  _onFinish = async (values: any): Promise<void> => {

    const type: GetFoodCardRecordListParameters['type'] = values.type

    const params: GetFoodCardRecordListParameters = {
      beginAt: moment(values.time).startOf('month').toISOString(),
      endAt: moment(values.time).endOf('month').toISOString(),
      type,
      kioskVendingId: values.kioskVendingId,
    }

    const res = await api.GetFoodCardRecordList({
      scope: ['foodCard', 'kioskVending', 'area', 'product'],
      isDownloadXlsx: true,
      count:10000000000,
      ...params,
    })
    if (res.kind !== 'ok') throw Error(res.kind)

    this.props.onFinish && this.props.onFinish(res.data)

  }

  _getKioskVendingList = async (params: GetKioskVendingListParameters) => {
    const res = await api.GetKioskVendingList(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  _onLoadData = async (): Promise<any> => {

    const kioskVendingList = await this._getKioskVendingList({ count: 1000 })

    this.setState({
      kioskVendings: kioskVendingList.data,
    })

    return {}

  };

  // from?: number
  // count?: number
  // isAscend?: boolean
  // searchText?: string
  // scope?: ('kioskVending' | 'foodCard' | 'area' | 'product')[]
  // status?: 'NORMAL' | 'ERROR'
  // foodCardId?: string
  // kioskVendingId?: string
  // areaId?: string
  // type?: 'QR_CODE' | 'OCTOPUS'
  // beginAt?: string
  // endAt?: string

  _formListData = (): FormItemData[] => {
    return [
      {
        id: 'type',
        label: '取餐方式',
        rules: [
          {
            required: false,
          }
        ],
        componet: (
          <Select
            placeholder="請選擇取餐方式"
            allowClear
            options={[
              {
                label: <Tag color={'blue'}>二維碼</Tag>,
                value: 'QR_CODE',
              },
              {
                label: <Tag color={'green'}>八達通</Tag>,
                value: 'OCTOPUS',
              },
            ].map(data => {
              return {
                value: data.value,
                label: data.label,
                disabled: false,
              }
            })}
          />
        )
      },
      {
        id: 'kioskVendingId',
        label: '取餐機',
        rules: [
          {
            required: false,
          }
        ],

        // allowClear: true,
        // showSearch: true,
        // filterOption: (input, option) => {
        //   if (option && option.key) {
        //     return (this.state.kioskVendings[Number(option.key)].name as string).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
        //       (this.state.kioskVendings[Number(option.key)].code as string).toLowerCase().indexOf(input.toLowerCase()) >= 0
        //   }
        //   return false
        // },
        // options:

        componet: (
          <Select
            placeholder="請選擇取餐機"
            allowClear
            showSearch
            filterOption={(input, option) => {
              if (option && option.key) {
                return (this.state.kioskVendings[Number(option.key)].name as string).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  (this.state.kioskVendings[Number(option.key)].code as string).toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              return false
            }}
            options={
              this.state.kioskVendings.map(kioskVending => {
                return {
                  value: kioskVending.id,
                  label: (
                    <Space align='center' >
                      <Tag color={'orange'}>{kioskVending.name}</Tag>
                      <Tag color={'blue'}>{kioskVending.code}</Tag>
                    </Space>
                  ),
                  disabled: false,
                }
              })}
          />
        )
      },

      {
        id: 'time',
        label: '選擇月份',
        rules: [
          {
            required: true,
            message: '請選擇月份',
          }
        ],
        componet: (
          <DatePicker picker='month'
            disabledDate={(current) => {
              // 禁用当前日期之后的月份（含未来）
              return current && current > moment().endOf('month');
            }}
          />
        )
      },

      {
        id: 'submit',
        label: '導出',
      },
    ]
  }

  render() {
    return (
      <div id="FoodCardRecordEditAndAdd">
        <JJ_From
          formListData={this._formListData()}
          onLoadData={this._onLoadData}
          onFinish={this._onFinish}
        />
      </div>
    )
  }

}
export default connector(FoodCardRecordEditAndAdd)
